import React, { useState } from "react";

function Kullanici() {
  // Örnek kullanıcı verileri
  const [kullanicilar, setKullanicilar] = useState(
    Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      name: `Kullanıcı ${i + 1}`,
      email: `kullanici${i + 1}@example.com`,
      phone: `555-000-${i + 100}`,
      address: `Adres ${i + 1}`,
      createdAt: `2024-11-${(i % 30) + 1}`,
    }))
  );

  // Popup durumu
  const [popupKullanici, setPopupKullanici] = useState(null);

  // Sayfalama için state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  // Sayfa başı ve sonu
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = kullanicilar.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(kullanicilar.length / itemsPerPage);

  return (
    <div className="min-h-screen bg-sky-100 p-8 rounded shadow">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Kullanıcılar</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow rounded">
          <thead>
            <tr>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                ID
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Adı
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                E-posta
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Telefon
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Kayıt Tarihi
              </th>
              <th className="px-6 py-3 border-b text-left text-sm font-medium text-gray-700">
                Aksiyon
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((kullanici) => (
              <tr key={kullanici.id} className="hover:bg-gray-100">
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {kullanici.id}
                </td>
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {kullanici.name}
                </td>
                <td className="px-6 py-3 border-b text-sm text-gray-700 truncate">
                  {kullanici.email}
                </td>
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {kullanici.phone}
                </td>
                <td className="px-6 py-3 border-b text-sm text-gray-700">
                  {kullanici.createdAt}
                </td>
                <td className="px-6 py-3 border-b text-sm text-blue-500">
                  <button
                    className="hover:underline"
                    onClick={() => setPopupKullanici(kullanici)}
                  >
                    Görüntüle
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Sayfa Değiştirme */}
      <div className="mt-4 flex justify-between items-center">
        <button
          className={`px-4 py-2 rounded ${
            currentPage === 1
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => prev - 1)}
        >
          Önceki
        </button>
        <p className="text-gray-700">
          Sayfa {currentPage} / {totalPages}
        </p>
        <button
          className={`px-4 py-2 rounded ${
            currentPage === totalPages
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-blue-500 text-white hover:bg-blue-600"
          }`}
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
          Sonraki
        </button>
      </div>

      {/* Kullanıcı Bilgileri Popup */}
      {popupKullanici && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded shadow-lg w-96">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              Kullanıcı Bilgileri
            </h2>
            <p className="text-sm text-gray-600 mb-2">
              <strong>ID:</strong> {popupKullanici.id}
            </p>
            <p className="text-sm text-gray-600 mb-2">
              <strong>Adı:</strong> {popupKullanici.name}
            </p>
            <p className="text-sm text-gray-600 mb-2">
              <strong>E-posta:</strong> {popupKullanici.email}
            </p>
            <p className="text-sm text-gray-600 mb-2">
              <strong>Telefon:</strong> {popupKullanici.phone}
            </p>
            <p className="text-sm text-gray-600 mb-4">
              <strong>Adres:</strong> {popupKullanici.address}
            </p>
            <p className="text-sm text-gray-600 mb-4">
              <strong>Kayıt Tarihi:</strong> {popupKullanici.createdAt}
            </p>
            <div className="flex justify-end">
              <button
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                onClick={() => setPopupKullanici(null)}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Kullanici;
